const styles = (theme) => ({
  actionButton: {
    marginTop: theme.spacing(4),
  },
});

export default styles;
